import React from "react";
import bannerimage from "../../Assets/images/features/featuresimg.png";
import resumeimage1 from "../../Assets/images/features/f1.png";
import resumeimage2 from "../../Assets/images/features/f2.png";

import autoimage1 from "../../Assets/images/features/f3.svg";
import autoimage2 from "../../Assets/images/features/f4.png";

import liveimage from "../../Assets/images/features/f5.png";

import liveimage1 from "../../Assets/images/features/f6.svg";
import liveimage2 from "../../Assets/images/features/f7.png";

import cheatimage from "../../Assets/images/features/f8.png";

import cheatimage1 from "../../Assets/images/features/f9.png";
import cheatimage2 from "../../Assets/images/features/f10.png";

import interviewimage from "../../Assets/images/features/f11.png";

import interviewimage1 from "../../Assets/images/features/f12.png";
import interviewimage2 from "../../Assets/images/features/f13.png";

import smartimages from "../../Assets/images/smart-summaries.svg";
import live from "../../Assets/images/live-behaviour.svg";
import seamless from "../../Assets/images/seamless.svg";
import realtime from "../../Assets/images/real-time.svg";
import ann from "../../Assets/images/ann-shortlist-img.svg";

import mb1 from "../../Assets/images/mb-1.svg";
import mb2 from "../../Assets/images/m-img2.svg";
import mb3 from "../../Assets/images/mimg3.svg";
import mb4 from "../../Assets/images/mimg4.svg";
import mb5 from "../../Assets/images/mimg5.svg";
import videos from "./ResumeShortlistingVideo";
import ResumeVideo from "./videos/Main-2.mp4";
import WhyAnnVideo from "./videos/WhyAnnVideo.mp4";
import SeamlessInterview from "./videos/Seamless-Interview-Coordination-New.mp4";
import Dynamic from "./videos/Interactive-Video-Interviews-New-4.mp4";
import CheatDetectionVideo from "./videos/Cheat-Detection-New.mp4";
import sic_video from "./videos/Seamless-ATS-Integration.mp4";
const FeaturesData = {
  "resume-shortlisting": {
    title: "Resume Shortlisting",

    subtitle: "Say Goodbye to Manual Resume Screening",
    backgroundColor: "#fff",
    description:
      "Ann instantly analyzes resumes and job descriptions to shortlist the most relevant candidates—saving time, reducing bias, and improving quality of hire.",
    bannerimage: WhyAnnVideo,
    sections: [
      {
        heading: "Reduce Hours to Minutes",
        points: [
          "Intelligent automation quickly filters hundreds of resumes",
          "Delivers a ranked shortlist of top candidates in seconds",
          "Saves recruiters time by eliminating manual screening",
          "Enables immediate action on the most qualified applicants",
        ],
        image: resumeimage1,
      },

      {
        heading: "Fair and Unbiased Evaluation",
        text: "Ann eliminates unconscious bias by focusing only on skills, experience, and job relevance. Each candidate is evaluated fairly, creating an inclusive and merit-based hiring process.",
        points: [
          "Eliminates unconscious bias by focusing solely on skills and experience",
          "Evaluates based on job relevance, not personal factors",
          "Promotes an inclusive and diverse hiring process",
          "Supports merit-based decisions for better hiring outcomes",
        ],

        image: resumeimage2,
      },
    ],
    section2: [
      {
        heading: "How Ann Shortlists Smarter",
        text: "Beyond Keyword Matching",
        image: ann,
        image2: mb1,
      },
    ],
    thirdsection: [
      {
        heading: "Ready to Shortlist Smarter with Ann?",
        text: "Let AI take the guesswork out of resume screening. Get accurate, fast, and fair results—every time.",
        button: "Request a Demo",
      },
    ],
  },

  "automated-scheduling": {
    title: "Automated Scheduling",
    subtitle: "Scheduling That Works While You Don’t",
    backgroundColor: "#f8f7fe",
    featuresWrapperBg: "#fff",
    description:
      "Ann handles interview scheduling in real time — no back-and-forth emails, timezone confusion, or manual coordination.",
    bannerimage: SeamlessInterview,
    sections: [
      {
        heading: "Reduce Drop-Offs, Improve Experience",
        text: "Keep candidates engaged with fast, personalized scheduling links and reminders. Ann ensures a seamless experience across time zones and devices.",
        points: [
          "Improves candidate experience through seamless interactions",
          "Fast, personalized scheduling links for quick interview setup",
          "Automated reminders to keep candidates informed and engaged",
          "Supports all time zones and devices for maximum convenience",
        ],

        image: autoimage1,
      },
      {
        heading: "Sync With Your Stack",
        text: "Ann integrates with popular calendars and ATS platforms, keeping your workflow uninterrupted. From Google Calendar to Outlook, everything stays in sync.",
        points: [
          "Integrates with popular calendars like Google Calendar and Outlook",
          "Compatible with leading ATS platforms for smooth recruitment flow",
          "Keeps your workflow uninterrupted and organized",
          "Ensures real-time updates across all connected systems",
        ],

        image: autoimage2,
      },
    ],
    section2: [
      {
        heading: "Effortless Coordination",
        text: "Smarter recruitment starts here.",
        image: realtime,
        image2: mb2,
      },
    ],
    thirdsection: [
      {
        heading: "Ready to Shortlist Smarter with ANN?",
        text: "Let AI take the guesswork out of resume screening. Get accurate, fast, and fair results—every time.",
        button: "Contact Us",
      },
    ],
  },
  "live-interviews": {
    title: "Live Interviews",
    subtitle: "Elevate Your Hiring with AI-Powered Live Interviews",
    description:
      "Conduct seamless, real-time interviews with Ann's AI-driven platform, ensuring consistent, unbiased, and efficient candidate evaluations.",
    bannerimage: Dynamic,
    sections: [
      {
        heading: "Enhance Candidate Engagement",
        // subtext: "Interactive and Personalized Interview Experience:",
        text: " Ann's AI interviewer adapts to each candidate, asking relevant follow-up questions and providing information about the role and company, ensuring a dynamic and engaging conversation.",
        points: [
          "Interactive and personalized interview experience",
          "AI interviewer adapts to each candidate in real-time",
          "Asks relevant follow-up questions based on responses",
          "Shares role and company information to keep candidates informed",
          "Creates a dynamic and engaging conversation throughout the interview",
        ],

        image: liveimage1,
      },
      {
        heading: "Comprehensive Post-Interview Insights",
        // subtext: "Data-Driven Decisions with Detailed Interview Reports:",
        text: "Post-interview, Ann generates comprehensive reports, including transcripts and key highlights, enabling hiring teams to make informed decisions based on consistent and objective data. ​",
        points: [
          "Data-driven decisions with objective, consistent evaluation",
          "Detailed interview reports generated automatically",
          "Includes transcripts and key highlights for easy review",
          "Empowers hiring teams with clear, actionable information",
        ],

        image: liveimage2,
      },
    ],
    section2: [
      {
        heading: "Transforming Interviews",
        text: "with Intelligent Automation",
        image: seamless,
        image2: mb3,
      },
    ],
    thirdsection: [
      {
        heading: "See AI Interviews in Action",
        text: "Discover how real-time interviews powered by AI can elevate your hiring process.",
        button: "Contact Us",
      },
    ],
  },

  "cheat-detection": {
    title: "Cheat Detection",
    subtitle: "Protect Every Interview with Confidence",
    description:
      "AI-powered cheat detection that ensures every candidate is evaluated fairly and transparently—no shortcuts, just clarity.",
    bannerimage: CheatDetectionVideo,
    sections: [
      {
        heading: "Clarity Through Reporting – Make Informed Hiring Decisions",
        text: "Every flagged behavior comes with detailed timestamps, context, and AI-generated reasoning—enabling hiring teams to evaluate with confidence, not guesswork.",
        points: [
          "Flagged behaviors include timestamps and context for full transparency",
          "AI-generated reasoning explains each flagged instance clearly",
          "Eliminates guesswork in the evaluation process",
          "Supports informed, confident hiring decisions with actionable insights",
        ],

        image: cheatimage1,
      },
      {
        heading: "Candidate-Respectful,Yet Secure",
        text: "Fairness is at the core—ANN protects the interview environment while maintaining a respectful, transparent process for every applicant. Feedback tools included for candidate clarity.",
        points: [
          "Fairness at the core of all evaluations",
          "Protects the interview environment to ensure integrity",
          "Maintains transparency throughout the process",
          "Includes feedback tools for clear communication with candidates",
        ],
        image: cheatimage2,
      },
    ],
    section2: [
      {
        heading: "Smart Detection Engine",
        text: "Always One Step Ahead",
        image: live,
        image2: mb4,
      },
    ],
    thirdsection: [
      {
        heading: "Let Ann Keep Your Interviews Honest",
        text: "Real-time monitoring. Fair feedback. Zero compromise.",
        button: "Contact Us",
      },
    ],
  },

  "interview-reports": {
    title: "Interview Reports",
    subtitle: "Get Rich, Real-Time Interview Reports",
    description:
      "Ann automatically generates detailed summaries, behavior insights, and feedback for every interview—delivered directly to your dashboard.",
    bannerimage: sic_video,
    sections: [
      {
        heading: "Seamless Integration, Zero Bottlenecks",
        text: "Ann's reports automatically plug into your ATS or internal systems, enriching every candidate profile with performance insights, video highlights, and feedback snapshots. No manual entry. Just smarter data.",
        points: [
          "Automatic report syncing enriches candidate profiles",
          "Includes performance insights, video highlights, and feedback snapshots",
          "Eliminates manual data entry for efficiency",
          "Delivers smarter, actionable recruitment data",
        ],
        image: interviewimage1,
      },
      {
        heading: "Feedback-Driven and Fair",
        text: "Each interview report includes candidate feedback to give your hiring team a full 360° view of every session. ANN prioritizes transparency and continuous improvement—for you and your applicants.",
        points: [
          "Includes candidate feedback for a full 360° view",
          "Promotes transparency throughout the hiring process",
          "Supports continuous improvement for both hiring teams and applicants",
          "Enhances fairness and clarity in every interview session",
        ],
        image: interviewimage2,
      },
    ],
    section2: [
      {
        heading: "Built-in Intelligence That Works for You",
        text: "Everything You Need to Evaluate, All in One Report",
        image: smartimages,
        image2: mb5,
      },
    ],
    thirdsection: [
      {
        heading: "Ready to Hire Smarter with Ann?",
        text: "Discover how AI-generated interview reports can help you make better, faster, and fairer hiring decisions—without the guesswork.",
        button: "Contact Us",
      },
    ],
  },
};

export default FeaturesData;
